export const displayLangCode = (lang: string) => {
  const [shortLangTitle] = lang.split('-')
  return shortLangTitle ? shortLangTitle.toUpperCase() : lang.toUpperCase()
}

export const displayFullLanguage = (lang: string) => {
  switch (lang) {
    case 'en-US':
      return 'English'
    case 'fr-CA':
      return 'French'
    default:
      return 'English'
  }
}
